import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { DetailedAgentArrivalHypothesis } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/Agents/components/Arrival/helpers/types';
import { HypothesesAccordion } from '../HypothesesAccordion';
import AgentArrivalHypothesis from './AgentArrivalHypothesis';

type Props = {
    detailedAgentArrivalHypothesesData: DetailedAgentArrivalHypothesis[];
    excludedAgentArrivalHypotheses?: number[];
    setExcludedAgentArrivalHypotheses?: (v: number[]) => void;
};

const ArrivalHypotheses = ({
    detailedAgentArrivalHypothesesData,
    excludedAgentArrivalHypotheses,
    setExcludedAgentArrivalHypotheses,
}: Props): React.ReactElement => {
    const { t } = useTranslation();

    return (
        <HypothesesAccordion
            title={t('humanResources.simulation.arrivalHypothesesResume')}
            badgeContent={detailedAgentArrivalHypothesesData.length}
        >
            <Box sx={{ margin: '1rem' }}>
                {detailedAgentArrivalHypothesesData.length === 0
                    ? t(
                          'humanResources.simulation.duplicateSimulation.noHypothesis',
                      )
                    : detailedAgentArrivalHypothesesData.map(
                          (hypothesis, index) => (
                              <Box key={index} sx={{ marginBottom: '2rem' }}>
                                  <AgentArrivalHypothesis
                                      hypothesis={hypothesis}
                                      excludedAgentArrivalHypotheses={
                                          excludedAgentArrivalHypotheses
                                      }
                                      setExcludedAgentArrivalHypotheses={
                                          setExcludedAgentArrivalHypotheses
                                      }
                                  />
                              </Box>
                          ),
                      )}
            </Box>
        </HypothesesAccordion>
    );
};

export default memo(ArrivalHypotheses);
